import {
  headingsPlugin,
  linkPlugin,
  listsPlugin,
  MDXEditor,
  quotePlugin,
  tablePlugin,
  thematicBreakPlugin,
} from '@mdxeditor/editor'

export interface MarkdownViewProps {
  markdown: string
}

export default function MarkdownView({
  markdown,
}: MarkdownViewProps) {
  return (
    <MDXEditor
      className="dark-theme"
      markdown={markdown}
      contentEditableClassName="markdown-view"
      readOnly
      plugins={[
        headingsPlugin(),
        listsPlugin(),
        linkPlugin(),
        quotePlugin(),
        thematicBreakPlugin(),
        tablePlugin(),
      ]}
    />
  )
}
